<template>
  <div class="wrapper">
    <div class="wrapper-header"></div>
    <div class="wrapper-body">
      <div class="wrapper-body-head">
        <img :src="headPortraitUrl" alt="">
      </div>
      <div class="wrapper-body-content">
        <span class="nickname web-font">黄头发的小女孩</span>
        <p class="notes web-font">
          我在睿识课买了几套「xxxxx」安全课程，课程有趣易懂、实用性强。送你一套，<br />快来领取和我一起学习吧
        </p>
        <div class="course-box">
          <div class="course-box-border"></div>
          <div class="course-box-cover">
            <div class="course-box-cover-shadow"></div>
            <img
              src="https://rskjy.oss-cn-beijing.aliyuncs.com/default/d6ed8a7fbe5f7efeb40c20c5e31c8a13.png?x-oss-process=image/resize,w_600"
            />
          </div>
        </div>
        <button class="receive web-font">领取课程</button>
      </div>
      <div class="wrapper-body-cover"></div>
      <div class="wrapper-body-adorn"></div>
    </div>
    <!-- 弹窗, 领取 -->
    <phone-verify v-if="phoneVerifyVisible" ref="phoneVerify"></phone-verify>
  </div>
</template>

<script>
import { getGiftDetails } from "@api/gift/";
import phoneVerify from './phoneVerify'
export default {
  name: "gift",
  data() {
    return {
      userName: "睿识课",
      headPortraitUrl: "",
      coverImgUrl: "",
      title: "",
      phoneVerifyVisible: false
    };
  },
  mounted() {
    this.getUrlParams();
    this.getDetails()
  },
  components: {
    phoneVerify
  },
  methods: {
    getUrlParams() {
      // this.coverImgUrl =
      //   "https://rskjy.oss-cn-beijing.aliyuncs.com/default/" +
      //   this.$route.query.thumbImageUrl;
      this.title = this.$route.query.title;
    },
    // 获取活动详情
    getDetails(){
      let param = { id:301905, giveType: 1 };
      getGiftDetails(param).then(({ data }) => {
        console.log(data)
        this.$toast(data.message);
        if (data.returnCode === '0000') {
          this.headPortraitUrl = data.data.headUrl
          this.coverImgUrl = data.data.goodsPicUrl
        } else {
          this.$toast(data.message);
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper
{
  position: relative;

  display: flex;
  overflow: hidden;
  flex-direction: column;

  width: 100%;
  height: 603px;

  background: linear-gradient(
  180deg,
  #fec6a7 0%,
  #ffe8da 41%,
  #ffc3af 67%,
  #ffd5bf 100%
  );
  &-header
  {
    position: absolute;
    top: 2px;
    left: 0;

    width: calc(100% - 10px);
    height: 48px;

    background: url(~@assets/img/gift/cloud@2x.png) no-repeat center;
    background-size: 100%;
  }
  &-body
  {
    position: relative;

    width: 100%;
    height: 553px;
    &-head
    {
      position: absolute;
      top: 14px;
      left: 50%;

      overflow: hidden;

      box-sizing: border-box;
      width: 84px;
      height: 84px;
      margin-left: -42px;

      border: 2px solid #fc8c6f;
      border-radius: 50%;
      img
      {
        width: 100%;
        height: 100%;
      }
    }
    &-content
    {
      display: flex;
      align-items: center;
      flex-direction: column;

      width: 334px;
      height: 496.47px;
      margin: 0 auto;
      margin-top: 32px;
      padding-top: 75px;

      background: url(~@assets/img/gift/bg_bottom@2x.png) no-repeat center;
      background-size: 100% 100%;
      .nickname
      {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;

        width: 140px;
        height: 28px;
        margin: 0 0;

        color: #fbf2ba;
        text-shadow: 0 1px 2px #be4a22;
      }
      .notes
      {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;

        width: 256px;
        height: 96px;
        margin: 15px 0 0 0;

        text-align: center;
        text-indent: 4px;

        color: #fff;
      }
      .course-box
      {
        position: relative;

        width: 298px;
        height: 163px;
        margin-top: 20px;
        &-border
        {
          box-sizing: border-box;
          width: 298px;
          height: 34px;

          border: 8px solid #ee9c45;
          border-radius: 6px;
          background: #631a0a;
        }
        &-cover
        {
          position: absolute;
          top: 7px;
          left: 13px;

          width: 272px;
          height: 153px;
          &-shadow
          {
            position: absolute;
            top: 0;
            left: 0;

            width: 272px;
            height: 43px;

            opacity: .75;
            border-radius: 1px;
            background: linear-gradient(
            180deg,
            rgba(0, 0, 0, .45) 0%,
            rgba(255, 255, 255, 0) 100%
            );
          }
          img
          {
            width: 100%;
            height: 100%;
          }
        }
      }
      .receive
      {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 22px;
        font-weight: 500;
        line-height: 40px;

        z-index: 4;

        width: 170px;
        height: 40px;
        margin-top: 96px;

        letter-spacing: 1px;

        color: #741920;
        border: none;
        border-radius: 23px;
        background: linear-gradient(180deg, #fbef6f 0%, #f0af3d 100%);
        &:focus
        {
          margin: 96px 0 0 0;

          outline: none;
        }
      }
    }
    &-cover
    {
      position: absolute;
      z-index: 3;
      top: 62px;
      left: 0;

      width: 100%;
      height: 541px;

      background: url(~@assets/img/gift/bg_up@2x.png) no-repeat center;
      background-size: 100% 100%;
    }
    &-adorn
    {
      position: absolute;
      z-index: 2;
      bottom: -20px;
      left: 8px;

      width: 102px;
      height: 155px;

      background: url(~@assets/img/gift/bg_leaf@2x.png) no-repeat center;
      background-size: 100% 100%;
    }
  }
}

</style>
